"use strict";
'use client';
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var apps_shared_1 = require("@l2p/apps-shared");
var swr_hooks_1 = require("@l2p/swr-hooks");
var ui_components_1 = require("@l2p/ui-components");
var next_intl_1 = require("next-intl");
var react_1 = __importDefault(require("react"));
var react_html_parser_1 = __importDefault(require("react-html-parser"));
var AuthButtons_1 = require("../../classic/Header/AuthButtons");
var PreviewGamesList_1 = require("../../classic/PreviewGamesList");
var Banner_1 = __importDefault(require("./Banner"));
var styles_module_scss_1 = __importDefault(require("./styles.module.scss"));
var Policy = function (_a) {
    var _b, _c;
    var title = _a.title, htmlContent = _a.htmlContent, gameCardPlaceholder = _a.gameCardPlaceholder, withButtons = _a.withButtons;
    var isAuth = (0, swr_hooks_1.useIsAuthorized)();
    var openDeposit = (0, apps_shared_1.useOpenDeposit)();
    var t = (0, next_intl_1.useTranslations)();
    var _d = (0, swr_hooks_1.useGamesByCategories)(), data = _d.data, isLoading = _d.isLoading;
    var games = (_c = (_b = data === null || data === void 0 ? void 0 : data['new']) === null || _b === void 0 ? void 0 : _b.previewGames) === null || _c === void 0 ? void 0 : _c.slice(0, 12);
    return (react_1.default.createElement("div", null,
        react_1.default.createElement(Banner_1.default, { title: t("policyPages.".concat(title)) }),
        react_1.default.createElement("div", { className: styles_module_scss_1.default.contentBox },
            react_1.default.createElement("div", { className: styles_module_scss_1.default.content }, (0, react_html_parser_1.default)(htmlContent)),
            withButtons && (react_1.default.createElement("div", { className: styles_module_scss_1.default.buttons }, isAuth ? (react_1.default.createElement(ui_components_1.FixedButton, { onClick: openDeposit, color: "gradient", text: "upper" }, t('translation.deposit'))) : (react_1.default.createElement(AuthButtons_1.AuthButtons, null))))),
        react_1.default.createElement("div", { className: styles_module_scss_1.default.games },
            react_1.default.createElement("h1", { className: styles_module_scss_1.default.title }, t('policyPages.newGames')),
            react_1.default.createElement("div", null, isLoading ? (react_1.default.createElement(ui_components_1.LoadingWithContainer, null)) : (react_1.default.createElement(PreviewGamesList_1.PreviewGamesList, { games: games, gameCardPlaceholder: gameCardPlaceholder }))))));
};
exports.default = Policy;
